import React from "react";
import { Box, Typography } from "@mui/material";
import { DeleteModal, NoticeboardButton } from "../shared";

interface CancelScheduledNoticeModalProps {
  open: boolean;
  onClose: () => void;
  noticeTitle: string;
  onConfirm: () => void;
  loading?: boolean;
}

const CancelScheduledNoticeModal: React.FC<CancelScheduledNoticeModalProps> = ({
  open,
  onClose,
  noticeTitle,
  onConfirm,
  loading = false,
}) => {
  return (
    <DeleteModal
      open={open}
      onClose={() => {
        if (loading) return;
        onClose();
      }}
      title="Cancel schedule"
      subtitle="This action cannot be undone"
      maxWidth="sm"
    >
      <Typography
        variant="body1"
        sx={{ mb: 3, fontSize: "1rem", lineHeight: 1.6 }}
      >
        Are you sure you want to cancel the scheduled notice{" "}
        <Typography component="span" fontWeight={600}>
          &ldquo;{noticeTitle}&rdquo;
        </Typography>
        ? It will be removed and will not go live at the scheduled time.
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <NoticeboardButton
          variant="danger"
          onClick={onConfirm}
          loading={loading}
          disabled={loading}
        >
          {loading ? "Cancelling..." : "Cancel schedule"}
        </NoticeboardButton>
      </Box>
    </DeleteModal>
  );
};

export default CancelScheduledNoticeModal;
